import { lazy } from 'react'
import { Route } from 'commons/types/route'
import { CREATE_PARTICIPANT, LIST_PARTICIPANT, UPDATE_PARTICIPANT } from 'commons/constants/permissions'

const GuestsListPage = lazy(() => import('pages/Guests/List'))
const GuestsCreatePage = lazy(() => import('pages/Guests/Create'))

export default [
  {
    path: '/guests',
    component: GuestsListPage,
    permissions: LIST_PARTICIPANT,
  },
  {
    path: '/guests/create',
    component: GuestsCreatePage,
    permissions: CREATE_PARTICIPANT,
  },
  {
    path: '/guests/update/:guestId',
    component: GuestsCreatePage,
    permissions: UPDATE_PARTICIPANT,
  },
] as Route[]
